// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3HS6U","header":"ReportDetails_header__3D7kC","title":"ReportDetails_title__3DNbX","left":"ReportDetails_left__bhFYm"};